var resources = require('items-view-strings');
    var strings = resources['_iy3tJlkicyKslyM9c5ecNQ'];
export { strings };
export default strings;
